import {
  Requirement,
  Status,
  Subfolder,
} from "../../../redux/interfaces/folder.types.ts";

export const groupByStatus = (
  requirements: Requirement[],
): Partial<Record<Status, Requirement[]>> => {
  return Object.groupBy(requirements, (req: Requirement) => req.status);
};

export const groupBySubfolder = (
  subfolders: Subfolder[],
): Partial<Record<string, Requirement[]>> => {
  const groupedBySubfolder: Record<string, Requirement[]> = {};

  // Key by subfolder.id (not slug) so several subfolders of the same role
  // (one per participant) render as separate groups instead of merging.
  subfolders.forEach((subfolder) => {
    groupedBySubfolder[subfolder.id] = [...subfolder.requirements];
  });

  return groupedBySubfolder;
};
